import styled from 'styled-components';

export const Container = styled.div`
  margin: 10px 120px;
  background: #f5f5f5;
`;

export const ListContainer = styled.button`
  position: relative;
  padding: 0;
  background: none;
  border: none;
  outline: 0;

  &:hover {
    opacity: 0.8;
  }
`;

export const ListCount = styled.div`
  position: absolute;
  width: 20px;
  height: 20px;
  background: #3f3e3e;
  color: white;
  border-radius: 50%;
  opacity: 1;
  font-size: 0.7rem;
  left: 16px;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;
